import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useUpdateDestinationGroupValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  return z.object({
    name: z.string().min(1, t('validation:required')),
    destinationsIds: z.array(z.number()).nonempty(t('validation:required')),
  });
};
